export default {
  // =========================
  // HEADER
  // =========================
  grn_title: "Goods Receipt Note (GRN)",
  
  grn_back: "Back to Orders",
  grn_no: "GRN No",

  // =========================
  // HEADER DETAILS
  // =========================
  grn_supplier: "Supplier",
  grn_received_by: "Received By",
  grn_date: "GRN Date",

  // =========================
  // TABLE
  // =========================
  grn_product: "Product",
  grn_uom: "UOM",
  grn_ordered: "Ordered",
  grn_received: "Received",
  grn_rejected: "Rejected",
  grn_status: "Status",

  // =========================
  // STATUS TEXT
  // =========================
  grn_short: "Short",
  grn_perfect: "Perfect",

  // =========================
  // SUMMARY
  // =========================
  grn_summary: "GRN Summary",
  grn_total_items: "Total Items",
  grn_total_ordered: "Total Ordered Qty",
  grn_total_received: "Total Received Qty",
  grn_total_rejected: "Total Rejected Qty",

  // =========================
  // REMARKS
  // =========================
  grn_remarks: "GRN Remarks",
  grn_remarks_placeholder: "Enter remarks (optional)",

  // =========================
  // SIGNATURE
  // =========================
  grn_tap_sign: "Tap to Sign",
  grn_upload_proof: "Upload Proof",            // ✅ NEW
  grn_signature_required: "Signature is required before confirming", // ✅ NEW

  // =========================
  // ACTIONS
  // =========================
  grn_save: "Save Draft",
  grn_confirm: "Confirm GRN",
  grn_download: "Download PDF",
  grn_print: "Print",                          // ✅ NEW

  // =========================
  // SUCCESS / ALERTS
  // =========================
  grn_success: "GRN Confirmed — Inventory successfully updated",
  grn_saved: "GRN saved successfully",         // ✅ NEW
  grn_error: "Something went wrong",           // ✅ NEW
  grn_pdf_not_ready: "PDF not available yet",  // ✅ NEW

  // =========================
  // GENERAL (REUSED)
  // =========================
  resview: "View",                             // (used in list page)
  resstatus: "Status",
resgoods_receipt_notes: "Goods Receipt Notes",

ressearch_grn_order: "Search GRN and Order ID",

resconfirmed_status: "Confirmed",
resdraft_status: "Draft",
respending_status: "Pending",
resrejected_status: "Rejected",

resgrn_no: "GRN No",
resorder: "Order",

resno_grns_found: "No GRNs found",

reset: "Reset",

};

